import React from 'react';
import {Container, Row} from 'reactstrap';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderSmallSize from '../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import PopupImageComponent from './PopupSharedComponents/PopupImageComponent';
import './IsInterestedToBuyFromOrg.scss';

const FailedSurfBlockRemovePopUp = (props) => {
  return (
    <Container className='InterestedToBuyInOrgPopup'>
      <PopupImageComponent icon={require('./images/lampIcon/lamp.svg')} />
      <PopupHeadlineComponent title={'המנוי חסום לגלישה בחו"ל'} />
      <PopupDescriptionComponent boldDescription={'התקנו לו חבילה גלישה אבל לא הצלחנו להסיר את החסימה. להמשך הטיפול פנו לאחראי השירות'} />
      <Row className='buttonsRow'>
        <BtnSubmit
          text={'הבנתי, תודה'}
          onclick={() => {
            props.closeModal();
          }}
        />
       
      </Row>
    </Container>
  );
};
export default FailedSurfBlockRemovePopUp;
